import {
    GET_GLOBAL_THRESHOLDS_SUCCESS,
    GET_GLOBAL_THRESHOLDS_FAIL,
    GET_GLOBAL_THRESHOLDS,
    POST_GLOBAL_THRESHOLD,
    POST_GLOBAL_THRESHOLD_FAIL,
} from "./actionTypes";

// CLOUD_RESOURCEs data

export const getGlobalThresholds = () => ({
  type: GET_GLOBAL_THRESHOLDS,
})

export const getGlobalThresholdsSuccess = gloablThresholds => ({
  type: GET_GLOBAL_THRESHOLD_SUCCESS,
  payload: gloablThresholds,
})

export const getGlobalThresholdsFail = error => ({
  type: GET_GLOBAL_THRESHOLD_FAIL,
  payload: error,
})

export const postGlobalThreshold = (gloablThreshold, history) => {
  return {
    type: POST_GLOBAL_THRESHOLD,
    payload: { cloudResouce, history }
  }
}

export const postGlobalThresholdFail = error => ({
  type: POST_GLOBAL_THRESHOLD_FAIL,
  payload: error,
})